import { useByokComplianceSettingWithInitialisation } from '@jira/admin-pages__products-jsm-compliance/src/useByokComplianceSettingWithInitialisation.tsx';
import { useOgTenantInfo } from '@atlassian/jira-eoc-tenant-info/src/controllers/index.tsx';
import { SERVICE_DESK } from '@atlassian/jira-shared-types/src/application-key.tsx';
import { FREE_EDITION, PREMIUM_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { useLicensedProducts } from '@atlassian/jira-tenant-context-controller/src/components/licensed-products/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsOrgAdmin } from '@atlassian/jira-business-goal-picker/src/services/is-org-admin/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { isIsolatedCloud } from '@atlassian/atl-context';

export const useFeatures = () => {
	const { isByokCustomer } = useByokComplianceSettingWithInitialisation();
	const isSiteAdmin = useIsSiteAdmin();
	const isAdmin = useIsAdmin();
	const { isOrgAdmin } = useIsOrgAdmin();
	const licensedProducts = useLicensedProducts();
	const { shouldUseJSM, loading: ogTenantInfoLoading, isOpsAdmin } = useOgTenantInfo();
	const appEditions = useAppEditions();

	const hasReports =
		!ogTenantInfoLoading &&
		(isSiteAdmin || isAdmin) &&
		!isByokCustomer &&
		shouldUseJSM &&
		!!licensedProducts[SERVICE_DESK] &&
		appEditions.serviceDesk !== FREE_EDITION &&
		!(fg('hide_reports_for_oasis') && isIsolatedCloud());

	const tenantContext = useTenantContext();

	const { appPermissions } = tenantContext;
	// Check if user has premium edition
	const isPremium = appEditions?.serviceDesk === PREMIUM_EDITION;

	// Check if user has specific product license
	const isJSMUser = appPermissions.hasServiceDeskAccess;
	const isAdminUser = isOrgAdmin || isAdmin || isOpsAdmin;

	const showCommunicationsMenu =
		isAdminUser && isPremium && isJSMUser && fg('communications_stakeholder_management_platform');

	const showStatuspageMenu =
		isAdminUser && isPremium && isJSMUser && fg('communications_status_page_manage_platform');

	return { hasReports, showCommunicationsMenu, showStatuspageMenu };
};
